@if (show) {
  <div style="display: flex; gap: 5px; width: 100%; flex-wrap: wrap; margin-top: 10px; box-sizing: border-box">
    <ngx-skeleton-loader count="1" appearance="line" style="width: 100%" [theme]="{ height: '100px', margin: '0' }" />
    <ngx-skeleton-loader count="1" appearance="line" style="width: 100%" [theme]="{ height: '300px', margin: '0' }" />
    @for (each of loaderItems(5); track each) {
      <ngx-skeleton-loader count="1" appearance="line" style="flex: 1 1 calc(18% - 2.5px)" [theme]="{ height: '50px', margin: '0' }" />
    }

    @for (each of loaderItems(5); track each) {
      <ngx-skeleton-loader count="1" appearance="line" style="width: 100%" [theme]="{ height: '200px', margin: '0' }" />
    }
  </div>
}
